import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pulsating" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1))
}
export default { render: render }